import { useCallback } from "react";
import dayjs from "dayjs";
import { normalizeTo13Digits, normalizeNotificationTimestamps } from "../utils/helpers";

export const useDateTimeLogic = () => {
  const handleDisplayNotificationDates = useCallback(
    (eventStartDate, configuration) => {
      if (eventStartDate) {
        const startDate = eventStartDate;
        const showOnHomePageStart =
          configuration.homeFeed >= 0
            ? dayjs.unix(startDate).subtract(configuration.homeFeed, "days")
            : dayjs.unix(startDate);
        const showOnHomePageEnd =
          configuration.homeFeed >= 0
            ? dayjs.unix(startDate).hour(23).minute(59).second(59)
            : dayjs.unix(startDate).subtract(configuration.homeFeed, "days");

        const showOnHomePage = [showOnHomePageStart, showOnHomePageEnd];

        let notificationInUtc = [];
        configuration.notifications
          .sort((a, b) => b - a)
          .forEach((dateDiff) => {
            const notificationDate = dayjs
              .unix(startDate)
              .subtract(dateDiff, "days");
            const currentDate = dayjs();
            const finalDate = notificationDate.isAfter(currentDate)
              ? notificationDate
              : currentDate;
            const dateStr = finalDate.format("YYYY-MM-DD");
            let utcTimestamp = dayjs.utc(dateStr).startOf("day").valueOf();
            utcTimestamp = normalizeTo13Digits(utcTimestamp);
            notificationInUtc.push(utcTimestamp);
          });

        notificationInUtc = Array.from(new Set(notificationInUtc));
        notificationInUtc = normalizeNotificationTimestamps(notificationInUtc);

        return {
          showOnHomePage,
          notificationInUtc,
        };
      }
      return null;
    },
    []
  );

  return { handleDisplayNotificationDates };
};
